<script>
export default {
  functional: true,
  props: {
    title: {
      type: String,
      require: true
    }
  },
  render(h, { data, props, scopedSlots }) {
    const { title } = props;
    return (
      <div class="Card" {...data}>
        <div class="Card__title">
          {scopedSlots.title ? scopedSlots.title() : title}
        </div>
        <div class="Card__content">{scopedSlots.default()}</div>
      </div>
    );
  }
};
</script>

<style lang="scss" scoped>
.Card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background:rgba(26,30,37,0.7);
  border:1px solid rgba(32,63,63,1);

  &__title {
    padding: 10px 16px;
    color: #00D3B8;
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(0,211,184,1);
  }

  &__content {
    flex: 1;
    overflow: hidden;
    padding: 0 16px;
  }
}
</style>
